import { useMemo } from 'react'
import { useController, UseFormReturn } from 'react-hook-form'

import { useGetTrips } from '@/modules/CombinedLogs/api/useGetTrips'
import { InputFormValues } from '@/modules/CombinedLogs/types'
import { SuggestionInputTable } from '@/ui/SuggestionInputTable'

import styles from './TableFormTripInput.module.scss'

interface Props {
    form: UseFormReturn<InputFormValues>
    setFocused: (focused: boolean) => void
}

const MAX_LENGTH = 4

export const TableFormTripToInput = ({ form, setFocused }: Props) => {
    const { field } = useController({ control: form.control, name: 'bulkCurtailmentTripTo' })
    const { data: trips } = useGetTrips()
    const trip = form.watch('trip')

    const options = useMemo(() => {
        const allTrips = trips ? [...trips.inbound, ...trips.outbound] : []
        const result = allTrips
            .map((item) => ({ id: item.id, label: item.trip.toString(), value: item.trip.toString() }))
            .sort((tripA, tripB) => +tripA.value - +tripB.value)

        if (!trip) {
            return result
        }

        return result.filter((item) => trip && +item.value > +trip)
    }, [trips, trip])

    return (
        <SuggestionInputTable
            options={options}
            value={field.value}
            variant="table"
            type="text"
            transparent
            fullWidth
            placeholder="To"
            className={styles.tripPopup}
            inputClassName={styles.tripInput}
            maxLength={MAX_LENGTH}
            onlyFromDropdown
            displayValueInsteadOfLabel
            onChange={(value) => {
                field.onChange(value)
                setFocused(false)
            }}
            onFocus={() => setFocused(true)}
        />
    )
}
